@let messageText = message().text;
@let messageFiles = message().files;
@let sentTime = message().created_at | date: 'hh:mm a';
@let messageStatusIcon = messageDeliveryStatus() === ChatMessageStatus.viewed ? 'done_all' : 'done';
@let repliesCount = message()?.replies_info?.messages_count;
@let isCompanyOwned = message()?.is_company_owned;

@if (!isThread()) {
  <div class="message-row" [class.is-mine]="isMine() || isCompanyOwned" [class.thread-opened]="threadIsOpened()">
    <div class="message-row__container">
      @if (!isMine()) {
        @if (showSender()) {
          <app-user-avatar
            radius="24px"
            [name]="sender()?.short_name"
            [avatar]="sender()?.avatar"
            [size]="24">
          </app-user-avatar>
        } @else {
          <div class="avatar-placeholder"></div>
        }
      }
  
      @if (isInternal()) {
        <div class="message-info">
          @if (!isMine() && showSender()) {
            <span class="sender">{{ sender()?.short_name }}</span>
          }
    
          <div class="message-data">
            @if (messageText) {
              <span class="message-body">{{ messageText }}</span>
            }
    
            @if (messageFiles?.length) {
              <div class="message-files">
                @for (file of messageFiles; track file.id) {
                  @if (isImage(file.content_type)) {
                    <app-chat-image
                      [imageUrl]="file.file"
                      (clickOnImage)="openImageView(file.id)">
                    </app-chat-image>
                  }
    
                  @if (isDocument(file.content_type)) {
                    <app-chat-doc [doc]="file"></app-chat-doc>
                  }
                }
              </div>
            }
    
            <div class="sent-time">
              <span class="time">{{ sentTime }}</span>
              @if (isMine()) {
                <mat-icon>{{ messageStatusIcon }}</mat-icon>
              }
            </div>
          </div>
    
          @if (repliesCount) {
            <div class="replies-container">
              <div class="replies" (click)="answerToThread()">
                <mat-icon class="material-icons-outlined">forum</mat-icon>
                <span class="replies-count">{{ repliesCount }} {{ (repliesCount > 1 ? 'messageCenter.replies' : 'messageCenter.reply') | translate }}</span>
              </div>
            </div>
          }

          <div class="actions">
            @if (!isMine()) {
              <mat-icon
                class="material-icons-two-tone icon-gray thread-icon"
                [matTooltip]="'messageCenter.replyInThread' | translate"
                (click)="answerToThread()">
                question_answer
              </mat-icon>
            } @else {
              @if (isInternal()) {
                <mat-icon
                  class="material-icons-two-tone icon-gray delete-icon"
                  [matTooltip]="'messageCenter.deleteMessage' | translate"
                  (click)="deleteMessage()">
                  delete
                </mat-icon>
              }

              @if (message().status === MessageStatus.notSent) {
                <mat-icon
                  class="material-icons-two-tone icon-red replay-icon"
                  [class.resending]="resending()"
                  [matTooltip]="'messageCenter.resendMessage' | translate"
                  (click)="resendMessage()">
                  replay
                </mat-icon>
              }
            }
          </div>
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="emailAndSmsTemplate"></ng-container>
      }
    </div>
  </div>
} @else {
  <div class="message-thread-row">
    <app-user-avatar
      radius="6px"
      [name]="sender()?.short_name"
      [avatar]="sender()?.avatar"
      [size]="32">
    </app-user-avatar>

    <div class="message-thread-row__info">
      <div class="info-row">
        <h6 class="sender-name">{{ sender()?.short_name }}</h6>
        <span class="sent-time">{{ message()?.created_at | date: 'MMM d, h:mm a' }}</span>
      </div>

      @if (messageText) {
        <span>{{ messageText }}</span>
      }

      @if (messageFiles?.length) {
        <div class="message-files">
          @for (file of messageFiles; track file.id) {
            @if (isImage(file.content_type)) {
              <app-chat-image
                [imageUrl]="file.file"
                (clickOnImage)="openImageView(file.id)">
              </app-chat-image>
            }

            @if (isDocument(file.content_type)) {
              <app-chat-doc [doc]="file"></app-chat-doc>
            }
          }
        </div>
      }

      @if (repliesCount) {
        <span class="replies">{{ repliesCount }} {{ (repliesCount > 1 ? 'messageCenter.replies' : 'messageCenter.reply') | translate }}</span>
      }
    </div>
  </div>
}

@if (showDivider()) {
  <div class="divider"></div>
}

<ng-template #emailAndSmsTemplate>
  <div class="email-sms-container">
    <div
      class="email-sms-container__head"
      [class.email]="isEmail()"
      [class.sms]="isSms()">
      <div class="icon-and-name">
        <mat-icon class="material-icons-outlined">{{ isEmail() ? 'mail' : 'sms' }}</mat-icon>
        <span class="name">
          {{ (isEmail() ? 'messageCenter.emailCommunication' : 'messageCenter.smsCommunication') | translate }}
        </span>
      </div>

      @if (isMine() || isCompanyOwned) {
        <span class="delivery-status-pill">{{ message().status_value }}</span>
      }
    </div>

    @if (isEmail()) {
      <div class="email-sms-container__subject">
        <h6>{{ message()?.subject }}</h6>
      </div>
    }

    <div class="email-sms-container__body">
      {{ messageText }}
    </div>

    <div class="email-sms-container__footer">
      @if (isSms()) {
        @if (isMine() || isCompanyOwned) {
          <div class="sender">
            {{ 'messageCenter.sentBy' | translate:{ name: sender()?.short_name } }}
            @if (isMine()) {
              ({{ 'messageCenter.you' | translate }})
            }
          </div>
        } @else {
          <div class="sent-from">
            <mat-icon class="material-icons-outlined">phone_iphone</mat-icon>
            <span>{{ 'messageCenter.from' | translate: { phone: sender()?.phone_number } }}</span>
          </div>
        }
      }

      <div class="delivery-info">
        <span class="sent-time">{{ sentTime }}</span>
        @if (isMine() || isCompanyOwned) {
          <mat-icon class="material-icons-outlined">{{ messageStatusIcon }}</mat-icon>
        }
      </div>
    </div>
  </div>
</ng-template>